import React, {Fragment, useMemo, useState} from "react";
import {Col, Modal, Row, Select} from "antd";
import {GUTTER_MD, MARGIN_XL, TABLE_COL_MIN_WIDTH_ID} from "../../../../../styles/constants";
import InfiniteScrollTable from "../../../../../components/infinite-scroll-table";
import {
    SELECT_TABLE_VIEW_CHOICES, TABLE_CHOICE,
    TABLE_VIEW_CHOICE, VIEW_CHOICE
} from "./utils";
import {compose} from "redux";
import {translate} from "react-i18next";
import {connect} from "react-redux";
import {deleteSelectedTableDatasetBuilder, selectCurrentTableDatasetBuilder} from "../actions";
import {BUTTON_DELETE, BUTTON_DETAIL} from "../../../../../styles/buttons";

const mapStateToProps = state => ({
    selectedTables: state.scenes.mappingHandler.datasetBuilder.unionModalProps.selectedTables,
    connections: state.scenes.mappingHandler.datasetBuilder.index.connections,
    connId: state.scenes.mappingHandler.datasetBuilder.index.connId,
});

const mapDispatchToProps = dispatch => ({
    setUserSelection: table => dispatch(selectCurrentTableDatasetBuilder(table)),
    deleteTable: id => dispatch(deleteSelectedTableDatasetBuilder(id))
});

const UnionTableSelectResult = ({t, setUserSelection, selectedTables, deleteTable, connections, connId}) => {
    const [selectedTableView, setSelectedTableView] = useState(TABLE_VIEW_CHOICE);
    const tableData = useMemo(() => selectedTables.filter(item => {
        if (selectedTableView === TABLE_CHOICE) {
            return item.type === "table"
        }
        if (selectedTableView === VIEW_CHOICE) {
            return item.type === "view"
        }
        return item.type === "view" || item.type === "table"
    }).map(item => ({...item, colNum: (item.aliasCols || []).length})), [selectedTables, selectedTableView]);
    const selectedConnection = useMemo(() => (connections || []).find(item => item.entityId === connId), [connections, connId]);

    return (
        <Fragment>
            <div style={selectedConnection && selectedConnection.dbType === 1 ? {paddingTop: GUTTER_MD + MARGIN_XL} : {paddingTop: 0}}>
                <InfiniteScrollTable
                    data={tableData}
                    getRowKey={({id}) => id}
                    columns={[{
                        title: t('data.datasetBuilder.type.shortLabel'),
                        dataIndex: 'type',
                        minWidth: TABLE_COL_MIN_WIDTH_ID
                    }, {
                        title: t('data.datasetBuilder.name.shortLabel'),
                        dataIndex: 'name',
                        minWidth: TABLE_COL_MIN_WIDTH_ID
                    }, {
                        title: t('data.datasetBuilder.colNum.label'),
                        dataIndex: 'colNum',
                    }
                    ]}
                    actions={[
                        {
                            ...BUTTON_DETAIL,
                            title: t('commons.actions.detail.title'),
                            onClick: (row) => {
                                const objToSend = {...row};
                                delete objToSend["__originalRow"]
                                setUserSelection(objToSend)
                            }
                        },
                        {
                            ...BUTTON_DELETE,
                            title: t('commons.actions.delete.title'),
                            onClick: (item, deselect) => Modal.confirm({
                                title: t('data.datasetBuilder.datasetDeleteModal.title', {
                                    datasetName: item.name
                                }),
                                onOk() {
                                    deselect();
                                    deleteTable(item.id)
                                },
                                cancelText: t('commons.buttons.cancel.title')
                            })
                        }
                    ]}
                    leftActions={<Row type="flex" gutter={GUTTER_MD}>
                        <Col>
                            <Select
                                showSearch
                                filterOption={(inputValue, {props}) =>
                                    props.title.toLowerCase().includes(inputValue.toLowerCase())
                                }
                                title={
                                    t('scenes.mappingHandler.DatasetBuilder.wizard.step.first.tableView')
                                }
                                value={selectedTableView}
                                onChange={(newValue) => setSelectedTableView(newValue)}
                            >
                                {SELECT_TABLE_VIEW_CHOICES.map((choice) => {
                                    return (
                                        <Select.Option
                                            key={choice.value}
                                            value={choice.value}
                                            title={choice.label}
                                        >
                                            {choice.label}
                                        </Select.Option>
                                    );
                                })
                                }
                            </Select>
                        </Col>
                    </Row>}
                />
            </div>
        </Fragment>
    )
}

export default compose(
    translate(),
    connect(mapStateToProps, mapDispatchToProps),
)(UnionTableSelectResult);